import { Trans, useTranslation } from 'react-i18next'

import { ExpertsStyles as S } from '~/pages/anatomy/experts/styles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const QUESTION = 'Anatomy by experts'
const UNIVERSITIES = ['Stanford', 'Oxford', 'Cambridge']

const AnatomyExperts = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('anatomy')
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: QUESTION,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.Title>
          <Trans ns="anatomy" i18nKey="onboarding.anatomyByExperts.title" />
        </S.Title>

        <S.Subtitle>
          <Trans ns="anatomy" i18nKey="onboarding.anatomyByExperts.subtitle" />
        </S.Subtitle>

        <S.UniversitiesWrapper>
          {UNIVERSITIES.map((university, index) => (
            <S.University key={university}>
              <S.UniversityLogo>{university.charAt(0)}</S.UniversityLogo>

              <S.UniversityContent>
                <S.UniversityDegree>
                  {index === 0
                    ? t('onboarding.anatomyByExperts.university')
                    : t('onboarding.anatomyByExperts.universityOf')}
                </S.UniversityDegree>

                <S.UniversityName>{university}</S.UniversityName>
              </S.UniversityContent>
            </S.University>
          ))}
        </S.UniversitiesWrapper>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default AnatomyExperts
